app.factory('delivery', ['$http','Config','$rootScope','CacheFactory', function($http,Config,$rootScope,CacheFactory) {

	var factoryFns =  {

	  getInstallDerig: function(data) {
	  	query = '?brand='+data.brand+
	  			'&delivery-postcode='+data.deliveryPostcode+
	  			'&collection-postcode='+data.collectionPostcode+
	  			'&cart-total-weight='+data.cartTotalWeight;

	  	return $http({
		  method: 'GET',
		  url: Config.api_url+'quote/transport'+query,
		  headers:{
		  	'authorization':Config.api_key
		  }
		});
	  },
	  getSurcharges: function(data){
	  	query = '?brand='+data.brand+
	  			'&delivery-postcode='+data.deliveryPostcode+
	  			'&collection-postcode='+data.collectionPostcode;
	  	return $http({
		  method: 'GET',
		  url: Config.api_url+'surcharges'+query,
		  headers:{
		  	'authorization':Config.api_key
		  }
		});
	  }, saveDeliveryChecklist: function(transport,quoteID){
		  	return $http({
			  method: 'POST',
			  data:{'transport':transport, 'quote-id':quoteID},
			  url: Config.api_url+'quote/save-delivery',
			  headers:{
			  	'authorization':Config.api_key
			  }
			});
	  }
	}
	return factoryFns;

}]);